// Common functions
function getCookie(n) {
  let a = `; ${document.cookie}`.match(`;\\s*${n}=([^;]+)`);
  return a ? a[1] : '';
}

function updateCookie(name, value) {
  let current_cookie = getCookie(name);
  if ((current_cookie && current_cookie != value) || !current_cookie) {
    document.cookie = name + '=' + value + ';path=/;';
  }
}

function deleteCookie(cookie) {
  document.cookie = cookie + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
}

//---------------------------------

// Move specs on resize screen
function moveOnResize(){
  function init(){
    let mobilePosition = document.querySelector('#product-extra-information .accordion--specs');
    let desktopPosition = document.querySelector('.product-info__block-list [data-block-type="quantity-selector"]');
    document.querySelectorAll('[data-block-type="specs-with-icons"]').forEach((spec) => {
      if (spec && mobilePosition && desktopPosition) {
        window.addEventListener('resize', (e) => {
          handleResize(spec, mobilePosition, desktopPosition);
        });
        handleResize(spec, mobilePosition, desktopPosition);
      }
    });
  }

  function handleResize(element, mobilePosition, desktopPosition){
    if (window.innerWidth < 999) {
      mobilePosition.append(element);
    } else {
      desktopPosition.before(element);
    }
  }
  init();
}


//----------------------------
// Handle Market Change cookies updates
function handleMarketChange(){
  function bindMarketSelectors() {
    let country_options = document.querySelectorAll('[name="country_code"]'),
      language_options = document.querySelectorAll('[name="locale_code"]');

    country_options.forEach(e => e.addEventListener('click', setMarketCookie));
    language_options.forEach(e => e.addEventListener('click', setMarketCookie));
  }

  function setMarketCookie(event) {
    let targetElement = event.target;
    if(!targetElement.name){
      targetElement = targetElement.closest('[name]');
    }
    if (event.isTrusted) {
      event.preventDefault();
      if (targetElement.name == "country_code") {
        updateCookie('country', targetElement.value);
        deleteCookie('language');
      } else {
        updateCookie('language', targetElement.value);
      }
      deleteCookie('market');
      updateCookie('open_popup', false);
      event.target.click();
    }
  }

  bindMarketSelectors();
}


// ----------------------------
// Click on contact for products
function clickOnContactForProducts(){
  const productContactButtons = document.querySelectorAll('[data-title][data-sku][data-handle]:not(.binded)');
  productContactButtons.forEach((button) => {
    button.classList.add('binded');
    button.addEventListener('click', (e) => {
      const productInfo = {
        sku: button.getAttribute('data-sku'),
        handle: button.getAttribute('data-handle'),
        title: button.getAttribute('data-title')
      }
      sessionStorage.setItem('contactProductInfo', JSON.stringify(productInfo));
    });
  });

  const contactForm = document.querySelector('#contact_form');
  if(contactForm && sessionStorage.getItem('contactProductInfo')){
    const productInfo = JSON.parse(sessionStorage.getItem('contactProductInfo'));
    const productInfosFields = `
      <input type="hidden" name="contact[product_title]" value="${productInfo.title}">
      <input type="hidden" name="contact[product_handle]" value="${productInfo.handle}">
      <input type="hidden" name="contact[product_sku]" value="${productInfo.sku}">
    `;
    contactForm.insertAdjacentHTML('beforeend', productInfosFields);
    sessionStorage.removeItem('contactProductInfo');
  }
}

document.addEventListener('DOMContentLoaded', (e)=>{
  moveOnResize();
  handleMarketChange();
  clickOnContactForProducts();
  document.addEventListener('facet:updated', clickOnContactForProducts);
});

document.addEventListener('DOMContentLoaded', () => {
  function updateCartStatusForReaders() {
    const statusElement = document.querySelector('[role="status"]');
    console.log('🚀 ~ updateCartStatus ~ statusElement:', statusElement);
    if (!statusElement) return;

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        cart.items.forEach(product => {
          let productStatusElement = statusElement.querySelector(`p[data-product-id="${product.id}"]`);

          if (!productStatusElement) {
            productStatusElement = document.createElement('p');
            productStatusElement.setAttribute('data-product-id', product.id);
            productStatusElement.setAttribute('current-quantity', product.quantity.toString());
            statusElement.appendChild(productStatusElement);

            const statusMessage = window.themeVariables.strings.cartStatus
              .replace('{{product_title}}', product.title || product.product_title)
              .replace('{{quantity}}', product.quantity);
            productStatusElement.textContent = statusMessage;
          } else if (parseInt(productStatusElement.getAttribute('current-quantity')) !== product.quantity) {
            productStatusElement.setAttribute('current-quantity', product.quantity.toString());
            const statusMessage = window.themeVariables.strings.cartStatus
              .replace('{{product_title}}', product.title || product.product_title)
              .replace('{{quantity}}', product.quantity);

            productStatusElement.textContent = statusMessage;
          }
        });

        const allStatusElements = statusElement.querySelectorAll('p[data-product-id]');
        allStatusElements.forEach(element => {
          const productId = element.getAttribute('data-product-id');
          const stillInCart = cart.items.some(item => item.id.toString() === productId);
          if (!stillInCart) {
            element.remove();
          }
        });
      })
      .catch(error => {
        console.error('Error updating cart status:', error);
      });
  }

  document.addEventListener('cart:change', () => {
    console.log(`cart changed`);
    updateCartStatusForReaders();
  });

  document.addEventListener('cart:refresh', () => {
    console.log(`cart refreshed`);
    updateCartStatusForReaders();
  });

  const isCart = document.querySelector('.shopify-section--main-cart');
  if (isCart) {
    updateCartStatusForReaders();
  }
});

/**
 * Focus on form error
 */
function focusOnFormError() {
  const formError = document.querySelector('[aria-label="error"]');
  if (formError) {
    formError.focus({ focusVisible: true, preventScroll: false });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  focusOnFormError();
});